import React from "react";

export const DOMAIN_LINKING_INTEGRATION_TABS = {
  GUIDE: 1,
  SETUP: 2,
  DISCONNECTION: 3,
};

const DOMAIN_LINKING_INTEGRATION_TAB_LABELS = {
  [DOMAIN_LINKING_INTEGRATION_TABS.GUIDE]: "Guide",
  [DOMAIN_LINKING_INTEGRATION_TABS.SETUP]: "Setup",
  [DOMAIN_LINKING_INTEGRATION_TABS.DISCONNECTION]: "Disconnection",
};

export const DOMAIN_LINKING_INTEGRATION_TAB_OPTIONS = [
  {
    label:
      DOMAIN_LINKING_INTEGRATION_TAB_LABELS[
        DOMAIN_LINKING_INTEGRATION_TABS.GUIDE
      ],
    value: DOMAIN_LINKING_INTEGRATION_TABS.GUIDE,
  },
  {
    label:
      DOMAIN_LINKING_INTEGRATION_TAB_LABELS[
        DOMAIN_LINKING_INTEGRATION_TABS.SETUP
      ],
    value: DOMAIN_LINKING_INTEGRATION_TABS.SETUP,
  },
  {
    label:
      DOMAIN_LINKING_INTEGRATION_TAB_LABELS[
        DOMAIN_LINKING_INTEGRATION_TABS.DISCONNECTION
      ],
    value: DOMAIN_LINKING_INTEGRATION_TABS.DISCONNECTION,
  },
];

export const DOMAIN_PRE_LINKING_STEPS = {
  ADD_DOMAIN: 0,
  SAVE_DNS_RECORDS: 1,
  NAME_SERVERS_SETUP: 2,
  NAME_SERVERS_VERIFICATION: 3,
  INITIATE_DOMAIN_LINKING: 4,
  DOMAIN_LINKING_INITIATED: 5,
  DOMAIN_LINKING_COMPLETED: 6,
};

export const DOMAIN_LINKING_FLAGS = {
  ADD_DOMAIN: 5,
  SAVE_DNS_INFO: 6,
  ADD_NAME_SERVER_INFO: 7,
  NAMESERVERS_VERIFIED: 20,
  COMPLETED: 100,
};

export const DOMAIN_LINKING_LOCAL_STORAGE_KEYS = {
  // the step stored in this key needs to be maintained on the front-end
  // currently, only SAVE_DNS_INFO and ADD_NAME_SERVER_INFO steps are handled on the front-end
  current_completed_step: "domain_linking_current_completed_step",
  refresh_domain_details: "refresh_domain_details",
};

export const DL_BENEFITS = [
  {
    label: "Your webpage domain will direct to your domain name",
    checked: true,
  },
  {
    label: "All your offerings links will change as per your domain name",
    checked: true,
  },
  {
    label: "Communications sent to your customers will have your domain links",
    checked: true,
  },
  {
    label: "You can manage your txt and mx records from Exly directly",
    checked: true,
  },
];

export const FEATURE_SECTIONS_STEPS = [
  {
    id: 1,
    label: "Create your Own Brand ✨",
    info: "Remove ‘powered by Exly’ branding from all your end-user pages. Also, customise your customer invoices.",
    show: "exly_branding_removal",
  },
  {
    id: 2,
    label: "Fully Customizable Footer 🪄",
    info: "Customize your home page and thank you page footers for your needs. Add or remove and manage your back links.",
    show: "exly_branding_removal",
  },
  {
    id: 3,
    label: "Got different Email sender IDs? 📧",
    info: "Engage your audience and nurture leads by broadcasting emails and setting up drips using different sender email IDs.",
    show: "email_sender_whitelabel",
  },
  {
    id: 4,
    label: "Connect your own number on Whatsapp 📢",
    info: "Sending messages from your brand name and respond to unlimited customer initiated conversations.",
    show: "whatsapp_whitelabel",
  },
];

export const DOMAIN_LINKING_DELINK_INSTRUCTIONS = {
  points: [
    <>
      Your home page, landing pages, checkout pages, any other shared links will
      not redirect to your domain related links
    </>,
    <>
      Your domain-linked Email sender IDs will get delinked from all broadcasts,
      drips and automated messages
    </>,
  ],
};
